import { GAME_MODES } from './gameConfig'
import type { GameMode, WordLength } from '../types/game'

export interface GameDef {
  // Internal/backend key - matches ChallengeType.slug and challengeApi's
  // challengeType param. Deliberately independent of the displayed `name`:
  // 'wordle' keeps its internal slug (matches ChallengeSession/DailySchedule
  // data already using it) while its public-facing name is "Zword" to avoid
  // using NYT's trademark as Zwizle's own product name.
  slug: 'wordle' | 'anagram'
  name: string
  tagline: string
  route: string
  modes: Record<WordLength, GameMode>
}

export const GAMES: Record<string, GameDef> = {
  wordle: {
    slug: 'wordle',
    name: 'Zword',
    tagline: 'Guess the Shona word of the day',
    route: '/zword',
    modes: GAME_MODES,
  },
  anagram: {
    slug: 'anagram',
    name: 'Anagram',
    tagline: 'Unscramble the Shona word of the day',
    route: '/anagram',
    modes: GAME_MODES,
  },
}
